import VEmpty from './index.vue';

export default {
  install: (Vue) => Vue.component('VEmpty', VEmpty),
};
